import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { AddSamplePOHeaderWithLineDto } from "../models/samplePO/details/addSamplePoDto";
import { CreatePurchaseOrderHeaderResponseDto } from "../models/samplePO/details/createPurchaseOrderHeaderResponseDto";
import { AddUpdateSamplePOLineDto } from "../models/samplePO/details/addUpdateSamplePOLineDto";
import { ConfirmPurchaseOrderResponseDto } from "../models/samplePO/details/confirmPurchaseOrderResponseDto";
import { CopyPOLinesRequestDto } from "../models/samplePO/details/copyPOLinesRequestDto";
import { DeleteSamplePOLineDto } from "../models/samplePO/details/deleteSamplePOLineDto";
import { SamplePOSummaryDto } from "../models/samplePO/details/samplePOSummaryDto";
import { UpdatePurchaseOrderHeaderDto } from "../models/samplePO/details/updatePurchaseOrderHeaderDto";
import { UpdateSamplePOLineDto } from "../models/samplePO/details/updateSamplePOLineDto";
import { StatusCodeDto } from "../models/shared/statusCodeDto";
import { PurchaseOrderLine } from "../models/samplePO/details/purchaseOrderLine";

@Injectable({
  providedIn: "root",
})
export class SamplepoSummaryService {
  private samplepoManagementBaseURL =
    environment.baseUrl + "/SamplePOMangement";
  constructor(private _http: HttpClient) {}

  getSamplePOSummary(
    samplePONumber: string
  ): Observable<GenericResponseDto<SamplePOSummaryDto>> {
    return this._http.get<GenericResponseDto<SamplePOSummaryDto>>(
      `${this.samplepoManagementBaseURL}/GetSamplePOSummary?samplePONumber=${samplePONumber}`
    );
  }
  addPOHeaderWithLine(
    payload: AddSamplePOHeaderWithLineDto
  ): Observable<GenericResponseDto<AddSamplePOHeaderWithLineDto>> {
    return this._http.post<GenericResponseDto<AddSamplePOHeaderWithLineDto>>(
      `${this.samplepoManagementBaseURL}/AddPOHeaderWithLine`,
      payload
    );
  }

  addPOLine(
    payload: AddUpdateSamplePOLineDto
  ): Observable<GenericResponseDto<AddUpdateSamplePOLineDto>> {
    return this._http.post<GenericResponseDto<AddUpdateSamplePOLineDto>>(
      `${this.samplepoManagementBaseURL}/AddPOLine`,
      payload
    );
  }

  confirmPurchaseOrder(
    purchaseOrderNumber: string | null | undefined
  ): Observable<GenericResponseDto<ConfirmPurchaseOrderResponseDto>> {
    return this._http.get<GenericResponseDto<ConfirmPurchaseOrderResponseDto>>(
      `${this.samplepoManagementBaseURL}/ConfirmPurchaseOrder?purchaseOrderNumber=${purchaseOrderNumber}`
    );
  }

  copyInventoryPurchase(
    purchaseOrderNumber: string | null | undefined
  ): Observable<GenericResponseDto<CreatePurchaseOrderHeaderResponseDto>> {
    return this._http.get<
      GenericResponseDto<CreatePurchaseOrderHeaderResponseDto>
    >(
      `${this.samplepoManagementBaseURL}/CopyInventoryPurchase?purchaseOrderNumber=${purchaseOrderNumber}`
    );
  }

  confirmInventoryPurchase(
    purchaseOrderNumber: string | null | undefined,
    invPurchaseCompleted: boolean
  ): Observable<GenericResponseDto<ConfirmPurchaseOrderResponseDto>> {
    return this._http.get<GenericResponseDto<ConfirmPurchaseOrderResponseDto>>(
      `${this.samplepoManagementBaseURL}/ConfirmInventoryPurchase?purchaseOrderNumber=${purchaseOrderNumber}&completed=${invPurchaseCompleted}`
    );
  }

  updateSamplePoHeader(
    payload: UpdatePurchaseOrderHeaderDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.put<GenericResponseDto<string>>(
      `${this.samplepoManagementBaseURL}/UpdatePurchaseOrderHeader`,
      payload
    );
  }

  updatePOLine(
    payload: UpdateSamplePOLineDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.put<GenericResponseDto<string>>(
      `${this.samplepoManagementBaseURL}/UpdatePOLine`,
      payload
    );
  }

  updatePOLineGroup(
    payload: UpdateSamplePOLineDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.put<GenericResponseDto<string>>(
      `${this.samplepoManagementBaseURL}/UpdatePOLineGroup`,
      payload
    );
  }

  deletePOLine(
    payload: DeleteSamplePOLineDto
  ): Observable<GenericResponseDto<DeleteSamplePOLineDto>> {
    return this._http.put<GenericResponseDto<DeleteSamplePOLineDto>>(
      `${this.samplepoManagementBaseURL}/DeletePOLine`,
      payload
    );
  }

  deleteLineGroup(
    lineGroupId: string
  ): Observable<GenericResponseDto<StatusCodeDto>> {
    return this._http.get<GenericResponseDto<StatusCodeDto>>(
      `${this.samplepoManagementBaseURL}/DeleteLineGroup?lineGroupId=${lineGroupId}`
    );
  }

  deleteInventoryLines(
    payload: number[]
  ): Observable<GenericResponseDto<StatusCodeDto>> {
    return this._http.put<GenericResponseDto<StatusCodeDto>>(
      `${this.samplepoManagementBaseURL}/DeleteInventoryLines`,
      payload
    );
  }

  getPurchaseOrderConfirmationJournal(
    purchaseOrderID: string
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      `${this.samplepoManagementBaseURL}/GetPurchaseOrderConfirmationJournal?PurchaseOrderID=${purchaseOrderID}`
    );
  }

  copyPOLines(
    payload: CopyPOLinesRequestDto
  ): Observable<GenericResponseDto<PurchaseOrderLine[]>> {
    return this._http.post<GenericResponseDto<PurchaseOrderLine[]>>(
      `${this.samplepoManagementBaseURL}/CopyPOLines`,
      payload
    );
  }
}
